import { GeneralAPI } from '../apis/GeneralAPI'
import Header from '../components/Header'
import BookingSection from '../components/MarketingAgenciesLanding/BookingSection'
import CampaignStrategy from '../components/MarketingAgenciesLanding/CampaignStrategy'
import FAQ from '../components/MarketingAgenciesLanding/FAQ'
import HowItWorks from '../components/MarketingAgenciesLanding/HowItWorks'
import MarketingAgenciesHero from '../components/MarketingAgenciesLanding/MarketingAgenciesHero'
import SocialProof from '../components/MarketingAgenciesLanding/SocialProof'
import WhyOLM from '../components/MarketingAgenciesLanding/WhyOLM'
import LandingPageWrapper from '../components/HomePage/LandingPageWrapper'

const MARKETING_AGENCIES_FALLBACK_META = `
<meta name="description" content="Get higher response rates with targeted direct mail. Proven templates, fast turnaround, and expert coaching to help you close more deals." />
<meta property="og:title" content="Direct Mail Marketing That Works" />
<meta property="og:description" content="Get higher response rates with targeted direct mail. Proven templates, fast turnaround, and expert coaching to help you close more deals." />
`

export default function MarketingAgencies({ data }) {
    return (
        <LandingPageWrapper sectionSpacing={false} paddingFromTop={false}>
            <Header
                meta={data?.yoast_head || MARKETING_AGENCIES_FALLBACK_META}
                metaTitle="Direct Mail Marketing That Works"
            />
            <MarketingAgenciesHero />
            <SocialProof />
            <CampaignStrategy />
            <WhyOLM />
            <HowItWorks />
            <FAQ />
            <BookingSection />

            <style
                dangerouslySetInnerHTML={{
                    __html: `
                @media (max-width: 640px) {
                    .marketing-agencies-form-grid {
                        grid-template-columns: 1fr !important;
                        padding: 20px !important;
                        gap: 16px !important;
                    }
                    .marketing-agencies-form-footer {
                        justify-content: center !important;
                        text-align: center;
                    }
                    .marketing-agencies-form-footer button {
                        width: 100%;
                    }
                }
            `,
                }}
            />
        </LandingPageWrapper>
    )
}

export async function getStaticProps() {
    let data = {}

    try {
        const page = await GeneralAPI.getPageBySlug('/marketing-agencies')
        data = page ? page[0] || {} : {}
    } catch (e) {
        console.error(e)
    }

    try {
        const { banners } = await GeneralAPI.getACFBanners()
        data.banners = banners
    } catch (e) {
        console.error(e)
    }

    return {
        props: {
            data,
            hideCartButton: true,
            hideLoginButton: true,
            phoneNumber: '978-893-5890',
        },
        revalidate: 10,
    }
}
